module.exports = __webpack_public_path__ + "media/images/farey/favicon-ceae880aaa4d9ce8a835d53b100737bc.ico";